import { Trans } from '@lingui/react/macro';
import type { ComponentProps } from 'react';

import SidebarIcon from '@/assets/svg/bx-sidebar.svg?react';
import Button from '@/components/buttons/Button/Button';
import { cn } from '@/lib/utils';

import useSidebar from './useSidebar';

export type SidebarTriggerProps = ComponentProps<typeof Button>;

const SidebarTrigger = ({ className, onClick, ...props }: SidebarTriggerProps) => {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      data-sidebar="trigger"
      data-slot="sidebar-trigger"
      variant="ghost"
      size="icon-small"
      className={cn(className)}
      onClick={(event) => {
        onClick?.(event);
        toggleSidebar();
      }}
      {...props}
    >
      <SidebarIcon className="rtl:-scale-x-100" />
      <span className="sr-only">
        <Trans>Toggle Sidebar</Trans>
      </span>
    </Button>
  );
};

export default SidebarTrigger;
